import React, { useEffect, useState } from 'react';
import { parseBreathCycle } from './sequenceModel';

/**
 * Visual inhale / exhale guide (expand / contract). Not TTS.
 */
export default function BreathingGuide({ breathText, paused = false }) {
  const { inhaleSeconds, exhaleSeconds } = parseBreathCycle(breathText);
  const [phase, setPhase] = useState('inhale'); // inhale | exhale

  useEffect(() => {
    if (paused) return undefined;
    let cancelled = false;
    let timeoutId;
    const cycle = (next) => {
      if (cancelled) return;
      setPhase(next);
      const ms = (next === 'inhale' ? inhaleSeconds : exhaleSeconds) * 1000;
      timeoutId = window.setTimeout(
        () => cycle(next === 'inhale' ? 'exhale' : 'inhale'),
        ms,
      );
    };
    cycle('inhale');
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [inhaleSeconds, exhaleSeconds, paused, breathText]);

  const expanding = phase === 'inhale';
  const duration = expanding ? inhaleSeconds : exhaleSeconds;

  return (
    <div className="yoga-breath" aria-live="polite">
      <div
        className={`yoga-breath__orb${expanding ? ' is-in' : ' is-out'}`}
        style={{
          transitionDuration: `${duration}s`,
          transform: expanding ? 'scale(1.08)' : 'scale(0.72)',
          opacity: expanding ? 1 : 0.75,
        }}
      />
      <div className="yoga-breath__label">
        {paused ? 'Paused' : expanding ? 'Inhale' : 'Exhale'}
      </div>
      {breathText ? (
        <p className="yoga-breath__cue u-muted u-small">{breathText}</p>
      ) : (
        <p className="yoga-breath__cue u-muted u-small">
          Soft nose breath · {inhaleSeconds}s in · {exhaleSeconds}s out
        </p>
      )}
    </div>
  );
}
